module.exports = __webpack_public_path__ + "media/images/proof_links/odnoklassniki-35deb3a7101bdb195da62b90bfe4f015.svg";